import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export default create()(
  immer((set, get) => ({
    sidebar: {
      isOpen: false,
      menuId: 0,
      kdSearch: '',
      columnsSearch: '',
      kdFilter: 'all',
    },
    homepage: {
      recommendationFilter: {},
    },
    explore: {
      isNewExplore: false,
      loading: {
        query: {},
        pusher: {},
        output: {},
      },
      currentMessageId: '',
      onExecution: true,
      updateFocusedMessage: false,
      canCreateNewConv: false,
    },
    messages: {
      userQuery: '',
      pusherMessages: {},
      kdQuery: {},
    },
    charts: {
      isFocused: false,
      suggestionsSearch: '',
      messageId: '',
      stepId: 1,
    },
    autoComplete: {
      show: false,
      loading: {
        homepage: false,
        messages: false,
      },
    },
    shareReport: {
      isOpen: false,
      type: '',
    },
    searchMetric: {
      open: false,
      detail: {},
      sidebar: 'none',
      metricCreating: false,
      currOutputGenerating: false,
      canExitPage: true,
      canStopDefCreate: false,
      convId: '',
    },
    feedback: {
      open: false,
      convId: '',
      mesgId: '',
      redo: false,
    },
    searchMessage: {
      isLast: true,
      triggerRefresh: false,
      shouldRefresh: false,
    },
    defaultDrillDownPath: {
      modalOpen: false,
      detail: {},
      refetch: false,
    },
    setSidebarOpen: (flag) =>
      set((state) => {
        state.isCollapsed = flag;
      }),
    setIsNewExplore: (flag) =>
      set((state) => {
        state.explore.isNewExplore = flag;
      }),
    setLoading: (key, messageId, flag) =>
      set((state) => {
        state.explore.loading[key][messageId] = flag;
      }),
    setPusherMessages: (messageId, message) =>
      set((state) => {
        state.messages.pusherMessages[messageId] = message;
      }),
    setUserQuery: (key, query) =>
      set((state) => {
        state[key].userQuery = query;
      }),
    setCurrentMessageId: (messageId) =>
      set((state) => {
        state.explore.currentMessageId = messageId;
      }),
    setHomepageRecommendationFilter: (filter) =>
      set((state) => {
        state.homepage.recommendationFilter = filter;
      }),
    setKDSearch: (keyword) =>
      set((state) => {
        state.sidebar.kdSearch = keyword;
      }),
    setColumnsSearch: (keyword) =>
      set((state) => {
        state.sidebar.columnsSearch = keyword;
      }),
    setKDQuery: (query) =>
      set((state) => {
        state.messages.kdQuery = query;
      }),
    setExploreExecutionStatus: (flag) =>
      set((state) => {
        state.explore.onExecution = flag;
      }),
    setChartsFocusMode: (flag) =>
      set((state) => {
        state.charts.isFocused = flag;
      }),
    setChartsSuggestionsSearch: (keyword) =>
      set((state) => {
        state.charts.suggestionsSearch = keyword;
      }),
    setChartsMessageId: (messageId) =>
      set((state) => {
        state.charts.messageId = messageId;
      }),
    setChartsStepId: (stepId) =>
      set((state) => {
        state.charts.stepId = stepId;
      }),
    setKDFilter: (filter) =>
      set((state) => {
        state.sidebar.kdFilter = filter;
      }),
    setShowAutoComplete: (flag) =>
      set((state) => {
        state.autoComplete.show = flag;
      }),
    setShareReport: (isOpen, type) =>
      set((state) => {
        state.shareReport.isOpen = isOpen;
        state.shareReport.type = type || state.shareReport.type;
      }),
    setShowAutoCompleteLoading: (key, flag) =>
      set((state) => {
        state.autoComplete.loading[key] = flag;
      }),
    setUpdateFocusedMessage: (flag) =>
      set((state) => {
        state.explore.updateFocusedMessage = flag;
      }),
    setSearchMetricOpen: (flag) =>
      set((state) => {
        state.searchMetric.open = flag;
      }),
    setSearchMetricDetails: (detail) =>
      set((state) => {
        state.searchMetric.detail = detail;
      }),
    setSidebar: (type) =>
      set((state) => {
        state.searchMetric.sidebar = type;
      }),
    setFeedbackOpen: (flag) =>
      set((state) => {
        state.feedback.open = flag;
      }),
    setFeedbackConvId: (id) =>
      set((state) => {
        state.feedback.convId = id;
      }),
    setFeedbackMesgId: (id) =>
      set((state) => {
        state.feedback.mesgId = id;
      }),
    setRedoOpen: (flag) =>
      set((state) => {
        state.feedback.redo = flag;
      }),
    setSearchLastMessage: (flag) =>
      set((state) => {
        state.searchMessage.isLast = flag;
      }),
    setSearchMetricCreating: (flag) =>
      set((state) => {
        state.searchMetric.metricCreating = flag;
      }),
    setCurrOutputGenerating: (flag) => {
      set((state) => {
        state.searchMetric.currOutputGenerating = flag;
      });
    },
    setDefaultDrillDownPathModalOpen: (flag) => {
      set((state) => {
        state.defaultDrillDownPath.modalOpen = flag;
      });
    },
    setDefaultDrillDownPathModalDetail: (detail) => {
      set((state) => {
        state.defaultDrillDownPath.detail = detail;
      });
    },
    setDrillDownPathsRefetch: (flag) => {
      set((state) => {
        state.defaultDrillDownPath.refetch = flag;
      });
    },
    setCanExitPage: (flag) => {
      set((state) => {
        state.searchMetric.canExitPage = flag;
      });
    },
    setCanStopDefCreate: (flag) => {
      set((state) => {
        state.searchMetric.canStopDefCreate = flag;
      });
    },
    setSearchMessageTriggerRefresh: (flag) => {
      set((state) => {
        state.searchMessage.triggerRefresh = flag;
      });
    },
    setSearchMessageShouldRefresh: (flag) => {
      set((state) => {
        state.searchMessage.shouldRefresh = flag;
      });
    },
    setCanCreateNewConv: (flag) => {
      set((state) => {
        state.explore.canCreateNewConv = flag;
      });
    },
    setCreateMetricConvId: (str) => {
      set((state) => {
        state.searchMetric.convId = str;
      });
    },
  }))
);
